import { Checkbox } from '@liveauctioneers/hammer-ui-core/checkbox';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import React from 'react';

type StatusProps = {
    checked: boolean;
    indeterminate: boolean;
};

const getCheckboxStatus = (array: any, selector: (input: any) => boolean): StatusProps => {
    const expectedNumber = array.length;
    const actualNumber = array.filter(selector).length;
    if (expectedNumber === 0 || actualNumber === 0) {
        return { checked: false, indeterminate: false };
    }
    if (expectedNumber === actualNumber) {
        return { checked: true, indeterminate: false };
    } else {
        return { checked: false, indeterminate: true };
    }
};

type Props = {
    array: any;
    category: string;
    onChange: (checkedOrIndeterminate: boolean) => void;
    selector: (input: any) => boolean;
    type: string;
};

const StatusCheckbox = ({ array, category, onChange, selector, type }: Props) => {
    const { formatMessage } = useIntl();
    const { checked, indeterminate } = getCheckboxStatus(array, selector);
    return (
        <Checkbox.Option
            aria-label={formatMessage({ id: 'notificationsPage.toggleAllNotifcations' }, { name: category, type })}
            checked={checked || indeterminate}
            className="mb-0 self-center"
            name="statusCheckbox"
            onChange={() => onChange(checked || indeterminate)}
        />
    );
};

export default React.memo<Props>(StatusCheckbox);
